const ModelDocumentData = {
    _id: {
        id: "_id",
        typeof: "string",
        required: true,
        default: "",
        description: "Document unique identifier.",
        fr: "ID",
        en: "ID",
        isVisible: true,
        disabled: false,
    },
    issueDate: {
        id: "issueDate",
        typeof: "date",
        required: true,
        default: null,
        description: "Issue date.",
        fr: "Date d'émission",
        en: "Issue date",
        isVisible: true,
        disabled: true,
    },
    documentNumber: {
        id: "documentNumber",
        typeof: "string",
        required: true,
        default: "",
        description: "Document number.",
        fr: "Numéro de document",
        en: "Document number",
        isVisible: true,
        disabled: false,
    },
    documentType: {
        id: "documentType",
        typeof: "select",
        required: true,
        default: "",
        description: "Document type.",
        fr: "Type de document",
        en: "Document type",
        isVisible: true,
        disabled: true,
    },
    issuer: {
        id: "issuer",
        typeof: "object",
        required: true,
        default: {},
        description: "Issuer.",
        fr: "Émetteur",
        en: "Issuer",
        isVisible: true,
        disabled: false,
    },
    customer: {
        id: "customer",
        typeof: "object",
        required: true,
        default: {},
        description: "Customer.",
        fr: "Client",
        en: "Customer",
        isVisible: true,
        disabled: false,
    },

    dueDate: {
        id: "dueDate",
        typeof: "date",
        required: true,
        default: null,
        description: "Due date.",
        fr: "Date d'échéance",
        en: "Due date",
        isVisible: true,
        disabled: false,
    },
    items: {
        id: "items",
        typeof: "array",
        required: true,
        default: [],
        description: "Document items.",
        isVisible: false,
        disabled: false,
    },

    vatExemptionNotes: {
        id: "vatExemptionNotes",
        typeof: "string",
        required: false,
        default: "",
        description: "VAT exemption notes.",
        fr: "Notes d'exonération de la TVA",
        en: "VAT exemption notes",
        isVisible: true,
        disabled: false,
    },
    documentStatus: {
        id: "documentStatus",
        typeof: "select",
        required: true,
        default: "",
        description: "Document status.",
        fr: "Statut du document",
        en: "Document status",
        isVisible: true,
        disabled: false,
    },
    memo: {
        id: "memo",
        typeof: "string",
        required: false,
        default: "",
        description: "Document notes.",
        fr: "Notes du document",
        en: "Document notes",
        isVisible: true,
        disabled: false,
    },

    totalQuantity: {
        id: "totalQuantity",
        typeof: "numberFloat",
        required: false,
        default: 0,
        description: "Total quantity of items.",
        fr: "Quantité totale",
        en: "Total quantity",
        isVisible: true,
        disabled: false,
    },
    totalVatExcluded: {
        id: "totalVatExcluded",
        typeof: "numberFloat",
        required: false,
        default: 0,
        description: "Total amount before taxes.",
        fr: "Total HT",
        en: "Total excl. VAT",
        isVisible: true,
        disabled: false,
    },
    discountRate: {
        id: "discountRate",
        typeof: "numberFloat",
        required: false,
        default: 0,
        description: "Discount rate applied to the document.",
        fr: "Taux de remise",
        en: "Discount rate",
        isVisible: true,
        disabled: false,
    },
    discountAmount: {
        id: "discountAmount",
        typeof: "numberFloat",
        required: false,
        default: 0,
        description: "Discount amount applied to the document.",
        fr: "Montant de la remise",
        en: "Discount amount",
        isVisible: true,
        disabled: false,
    },
    totalVatExcludedAfterDiscount: {
        id: "totalVatExcludedAfterDiscount",
        typeof: "numberFloat",
        required: false,
        default: 0,
        description: "Total amount after discount before taxes.",
        fr: "Total HT après remise",
        en: "Total excl. VAT after discount",
        isVisible: true,
        disabled: false,
    },
    totalVatIncluded: {
        id: "totalVatIncluded",
        typeof: "numberFloat",
        required: false,
        default: 0,
        description: "Total amount including taxes.",
        fr: "Total TTC",
        en: "Total incl. VAT",
        isVisible: true,
        disabled: false,
    },
    totalVat: {
        id: "totalVat",
        typeof: "numberFloat",
        required: false,
        default: 0,
        description: "Total VAT amount.",
        fr: "Total TVA",
        en: "Total VAT",
        isVisible: true,
        disabled: false,
    },
    currency: {
        id: "currency",
        typeof: "select",
        required: true,
        default: "",
        description: "Currency used for the document.",
        fr: "Devise",
        en: "Currency",
        isVisible: true,
        disabled: false,
    },
    paymentTerms: {
        id: "paymentTerms",
        typeof: "select",
        required: false,
        default: "net30",
        description: "Payment terms.",
        fr: "Conditions de paiement",
        en: "Payment terms",
        isVisible: true,
        disabled: false,
    },
    paymentMethod: {
        id: "paymentMethod",
        typeof: "select",
        required: false,
        default: "bankTransfer",
        description: "Payment method.",
        fr: "Mode de paiement",
        en: "Payment method",
        isVisible: true,
        disabled: false,
    },

};

const ModelDocumentItem = {

    _id: { id: '_id', typeof: 'string', required: true, default: '', fr: 'ID', en: 'ID', description: 'Unique identifier for the service item', isVisible: false, disabled: false },
    itemCode: { id: 'itemCode', typeof: 'string', required: true, default: '', fr: 'Code article', en: 'Item code', description: 'Item internal reference code', isVisible: true, disabled: false },
    designation: { id: 'designation', typeof: 'obj', required: true, default: '', fr: 'Désignation', en: 'Description', description: 'Item or service description', isVisible: true, disabled: false },
    unit: { id: 'unit', typeof: 'select', required: false, default: '-', fr: 'Unité', en: 'Unit', description: 'Unité de mesure (ex: pièce, palette, kg)', isVisible: true, disabled: false },
    currency: { id: 'currency', typeof: 'select', required: true, default: '', fr: 'Devise', en: 'Currency', description: 'Currency for client billing', isVisible: true, disabled: false },

    quantity: { id: 'quantity', typeof: 'numberFloat', required: true, default: 0, fr: 'Quantité', en: 'Quantity', description: 'Quantity', isVisible: true, disabled: false },
    unitPrice: { id: 'unitPrice', typeof: 'numberFloat', required: true, default: 0, fr: 'PU HT', en: 'Unit Price excl. VAT', description: 'Unit price excluding tax (HT) billed to the client', isVisible: true, disabled: false },
    totalVatExcluded: { id: 'totalVatExcluded', typeof: 'numberFloat', required: false, default: 0, fr: 'Total HT', en: 'Total excl. VAT', description: 'Total amount before taxes billed to the client', isVisible: true, disabled: false },

    discountRate: { id: 'discountRate', typeof: 'numberFloat', required: false, default: 0, fr: 'Taux de remise', en: 'Discount Rate', description: 'Discount rate (%) applied for the client', isVisible: true, disabled: false },
    discountAmount: { id: 'discountAmount', typeof: 'numberFloat', required: false, default: 0, fr: 'Montant de la remise', en: 'Discount Amount', description: 'Discount amount applied to the client line', isVisible: true, disabled: false },

    totalVatExcludedAfterDiscount: { id: 'totalVatExcludedAfterDiscount', typeof: 'numberFloat', required: false, default: 0, fr: 'Total HT', en: 'Total excl. VAT', description: 'Total amount before taxes billed to the client', isVisible: true, disabled: false },

    vatRate: { id: 'vatRate', typeof: 'select', required: false, default: 'tax_0', fr: 'Taux TVA', en: 'VAT Rate', description: 'Applicable VAT rate (%) for the customer', isVisible: true, disabled: false },
    vat: { id: 'vat', typeof: 'string', required: false, default: '', fr: 'TVA', en: 'VAT', description: 'Applicable VAT typeof or code', isVisible: true, disabled: true },
}


const ModelDocumentType = [
    {
        key: "quote",
        fr: "Devis",
        en: "Quote",
    },
    {
        key: "proforma",
        fr: "Proforma",
        en: "Proforma",
    },
    {
        key: "invoice",
        fr: "Facture",
        en: "Invoice",
    },
    {
        key: "creditNote",
        fr: "Note de crédit",
        en: "Credit note",
    },
]


const ModelDocumentStatus = [
    {
        key: "draft",
        fr: "Brouillon",
        en: "Draft",
    },
    {
        key: "paid",
        fr: "Payé",
        en: "Paid",
    },
    {
        key: "overdue",
        fr: "En retard",
        en: "Overdue",
    }, 
    {
        key: "cancelled",
        fr: "Annulé",
        en: "Cancelled",
    }, 
    {
        key: "paidPartial",
        fr: "Partiellement payé",
        en: "Paid Partial",
    }
]


const DocumentIssuer = {
    name: "GEOSHIP",
    address: "LES DOCKS SAINT-MARC",
    address2: "ZA SAINT-MARC SUD",
    postalCode: "61110",
    city: "REMALARD-EN-PERCHE",
    country: "FR",
    phone: "+33 9 70 71 82 30",
    email: "cargo@geoship.fr",
    webSite: "https://geoship.fr",
    siren: "951 928 506",
    vat: "FR91 951928506",
};

const DocumentIssuerBank = {
    bankName: "FIDUCIAL BANQUE",
    iban: "FR2111449000010139137001J87",
    bic: "BDEIFRPPXXX",
}

const DocumentNoteFooter = {
    text1: "Cette facture est payable comptant à réception sans aucun escompte. Le défaut de paiement à cette échéance entraîne sous réserve d’une mise en demeure, l’application d’intérêts de retard de 1,5 fois le taux d’intérêt légal en vigueur.",
    text2: "Indemnité forfaitaire de 40 € pour frais de recouvrement, en cas de retard de paiement."
}
const DocumentFooter = {
    text1: "GEOSHIP SAS - LES DOCKS SAINT-MARC - ZA SAINT-MARC SUD - 61110 REMALARD-EN-PERCHE - FRANCE (FR) - RCS ALENÇON",
    text2: "TEL : +33 9 70 71 82 30 - APE : 5229B - SIREN : 951 928 506 - TVA : FR91 951928506 - CAPITAL : 3 000€",
}



export {
    ModelDocumentData,
    ModelDocumentType,
    ModelDocumentStatus,
    ModelDocumentItem,
    DocumentIssuer,
    DocumentIssuerBank,
    DocumentNoteFooter,
    DocumentFooter
};
